import styled from "styled-components";

export const Wrapper = styled.div`
  .modal-input {
    border: 1px solid #dddddd;
    font-size: 15px;
    ::placeholder {
      color: #566787;
      font-size: 15px;
    }
  }

  .modal-label {
    color: #566787;
    font-size: 17px;
    padding-bottom: 4px;
    padding-left: 2px;
  }
`;
